import { GET_WS, GET_WS_SUCCESS, GET_WS_ERROR} from './actionTypes';

export const getWorkstations = (user) => {
    return {
        type: GET_WS,
        payload: { user }
    }
}

export const getWorkstationsSuccess = (ws, message) => {
    return {
        type: GET_WS_SUCCESS,
        payload: {ws, message}
    }
}

export const getWorkstationsError = (ws) => {
    return {
        type: GET_WS_ERROR,
        payload: ws
    }
}
